import React from "react";

export default function UserTieIcon(props) {
  const { size = 16 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 4a4 4 0 1 0 0 8a4 4 0 0 0 0-8zM8 12c-2.21 0-4 1.79-4 4v1h3.14l.86-2.65L9 18h6l1-3.65L16.86 17H20v-1c0-2.21-1.79-4-4-4H8z"
      />
    </svg>
  );
}
